import {
  getClientEnv
} from '../../../utils/common'

export const DEFAULT_ERROR_MSG = '服务器开小差，请稍后重试'

/**
 * 跳到商城下订单带上的渠道号，标识充电VIP业务
 */
export const MALL_ENTRY = '300054（其他）'

/**
 * 商城订单详情页，访问时需要拼接bizId，根据当前环境返回
 */
export const MALL_DETAIL_PAGE_URL = {
  'test': 'http://pmall.test.xiaopeng.local/order/detail/',
  'deploy': 'https://pmall.cs-pre.xiaopeng.com/order/detail/',
  'product': 'https://mall.xiaopeng.com/order/detail/'
}
export const mallDetailPageUrl = MALL_DETAIL_PAGE_URL[getClientEnv()]

/**
 * 支付完成后中转回跳页（与 charge-vip 同域部署）
 */
const REDIRECT_HOST_MAP = {
  test: 'http://static.test.xiaopeng.local',
  deploy: 'https://static.deploy-test.xiaopeng.com',
  product: 'https://static.xiaopeng.com',
}
export const PAY_RETURN_REDIRECT_URL = `${REDIRECT_HOST_MAP[getClientEnv()]}/apps/charge-web/redirect.html`


export const LEVEL_LIST = [
  {
    id: 1,
    name: 'V1充电新星',
    price: 100,
    originalPrice: 200,
    desc: 'VIP1描述',
    textUrl: 'https://s.xiaopeng.com/xp-charge/mini/chargeVip/charge-vip-name-v1.png',
    lineBackground: 'linear-gradient(270deg, #FFFFFF 0%, #ACD5DB 48%, #0A6773 100%)',
    btnBackgroundColor: 'linear-gradient(272deg, #B3FFF7 -48%, #F6FDFF 94%)',
    limit: 0,
    level: 1
  },
  {
    id: 2,
    name: 'V2充电先锋',
    price: 200,
    originalPrice: 400,
    desc: 'VIP2描述',
    textUrl: 'https://s.xiaopeng.com/xp-charge/mini/chargeVip/charge-vip-name-v2.png',
    lineBackground: 'linear-gradient(270deg, #FFFFFF 0%, #E0F9F1 48%, #1FCE98 100%)',
    btnBackgroundColor: 'linear-gradient(270deg, #6CEFC8 -46%, #F6FDFF 99%)',
    limit: 200,
    level: 2
  },
  {
    id: 3,
    name: 'V3充电领航',
    price: 300,
    originalPrice: 600,
    desc: 'VIP3描述',
    textUrl: 'https://s.xiaopeng.com/xp-charge/mini/chargeVip/charge-vip-name-v3.png',
    lineBackground: 'linear-gradient(270deg, #FFF0FF 0%, #E9EAFF 50%, #2AB3FF 100%)',
    btnBackgroundColor: 'linear-gradient(272deg, #ACD4FB -4%, #F6FDFF 96%)',
    limit: 500,
    level: 3
  }
]
